import React from "react";
import { Route } from "react-router";
import Header from "../Common/Header";

const HeaderLayout = ({ children }) => {
  return (
    <div>
      <Header>{children}</Header>
    </div>
  );
};

const HeaderLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <HeaderLayout>
          <Component {...matchProps} />
        </HeaderLayout>
      )}
    />
  );
};

export default HeaderLayoutRoute;
